import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { Component } from 'inferno';
import { createElement } from 'inferno-create-element';

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === void 0 ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ["component", "innerRef", "children"]);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);

    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({
      arrowProps: arrowProps,
      restProps: restProps
    });
  }

  var componentProps = _objectSpread({}, restProps, {
    style: _objectSpread({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return createElement(component, componentProps, children);
};

export default Arrow;


// WEBPACK FOOTER //
// ./node_modules/inferno-popper/lib/Arrow.js